// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3j6uU","rightAdornment":"Header_rightAdornment__3d9KU"};